<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="typeValue"
          label="Tip"
          :items="[{value: 1, text: 'Müşteri Çeki'},{value: 2, text: 'Borç Çeki'}]"
          item-value="value"
          item-text="text"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(inputStartDate)"
              label="Giriş Başlangıç Tarihi"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="inputStartDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="inputStartDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(inputEndDate)"
              label="Giriş Bitiş Tarihi"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="inputEndDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="inputEndDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(outputStartDate)"
              label="Çıkış Başlangıç Tarihi"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="outputStartDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="outputStartDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(outputEndDate)"
              label="Çıkış Bitiş Tarihi"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="outputEndDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="outputEndDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(expiryStartDate)"
              label="Vade Başlangıç Tarihi"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.expiryStartDate, 'Vade Başlangıç Tarihi')
                    "
              @input="$v.expiryStartDate.$touch()"
              @blur="$v.expiryStartDate.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="expiryStartDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="expiryStartDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(expiryEndDate)"
              label="Vade Bitiş Tarihi"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.expiryEndDate, 'Vade Bitiş Tarihi')
                    "
              @input="$v.expiryEndDate.$touch()"
              @blur="$v.expiryEndDate.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="expiryEndDate = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="expiryEndDate"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (givingCurrent = e)"
          :label="'Veren'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (givenCurrent = e)"
          :label="'Verilen'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-text-field
          v-model="documentNumberValue"
          label="Belge No"
          filled
          solo
          dense
      >

      </v-text-field>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="reportDbName"
          label="Şirket Adı"
          filled
          solo
          dense
          clearable
          :items="companyList"
          item-text="name"
          item-value="name"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="location"
          label="Yer"
          filled
          solo
          dense
          clearable
          :items="locationOptions"
          item-text="name"
          item-value="key"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport">
        <v-icon left>mdi-filter</v-icon>
        FİLTRELE
      </v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "CekRaporu",
  components: {SearchSelect},
  props: {
    reportType: {
      type: Object,
      default: () => {
      }
    }
  },
  mounted() {
    this.fetchCompanyList({
      params: {},
      body: {}
    })
  },
  computed: {
    ...mapState("company", ["companyList"]),
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      inputStartDate: null,
      inputEndDate: null,
      outputStartDate: null,
      outputEndDate: null,
      expiryStartDate: null,
      expiryEndDate: null,
      typeValue: 1,
      givingValue: null,
      givenValue: null,
      documentNumberValue: null,
      reportDbName: null,
      givingCurrent: null,
      givingCurrentSearchText: null,
      searchGivingCurrentLoading: false,
      givingCurrentSearchResult:[],
      searchGivingCurrentTimeout: null,
      givenCurrent: null,
      givenCurrentSearchText: null,
      searchGivenCurrentLoading: false,
      givenCurrentSearchResult:[],
      searchGivenCurrentTimeout: null,
      location: null,
      locationOptions: [
        {
          key: 1,
          name: "Portföy"
        },
        {
          key: 2,
          name: "Ciro",
        },
          {
          key: 3,
            name: "Tahsil",
        },
          {
          key: 4,
            name: "Teminat",
        },
        {
          key: 5,
          name: "İade",
        },
        {
          key: 6,
          name: "Avukat",
        }
      ],
    }
  },

  validations: {
    expiryStartDate: {
      required,
    },
    expiryEndDate: {
      required,
    },
  },

  methods: {
    ...mapActions("company", ["fetchCompanyList"]),
    ...mapActions("current", ["fetchCurrentList"]),
    formattedDate,
    validationMessages,
    filterReport() {
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          Type: this.typeValue, // 1 ise Müşteri Çeki 2 ise Borç Çeki
          InputStartDate: this.inputStartDate,
          InputEndDate: this.inputEndDate,
          OutputStartDate: this.outputStartDate,
          OutputEndDate: this.outputEndDate,
          ExpiryStartDate: this.expiryStartDate,
          ExpiryEndDate: this.expiryEndDate,
          Giving: this.givingCurrent,
          Given: this.givenCurrent,
          DocumentNumber: this.documentNumberValue,
          ReportDbName: this.reportDbName,
          Location: this.location,
        };
        this.$emit("reportFilterChange", this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
    async searchGivingCurrentList() {
      this.givingCurrentSearchResult = await this.fetchCurrentList({
        params: {
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.givingCurrentSearchText == "" || this.givingCurrentSearchText == null  ? false : true) && {searchText: this.givingCurrentSearchText }
        },
        body: {

        },
        onlyData: true,
        loading: false
      });
      this.searchGivingCurrentLoading = false

    },
    async searchGivenCurrentList() {
      this.givenCurrentSearchResult = await this.fetchCurrentList({
        params: {
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.givenCurrentSearchText == "" || this.givenCurrentSearchText == null  ? false : true) && {searchText: this.givenCurrentSearchText }
        },
        body: {

        },
        onlyData: true,
        loading: false
      });
      this.searchGivenCurrentLoading = false

    }
  },
  watch: {
    givingCurrentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        if(this.searchGivingCurrentTimeout)
          clearTimeout(this.searchGivingCurrentTimeout);
        this.searchGivingCurrentLoading = true;
        this.givingCurrentSearchResult = [];
        this.searchGivingCurrentTimeout = setTimeout(() => {
          this.searchGivingCurrentList();
        },1500);
      }
      else
      {
        this.searchGivingCurrentLoading = false;
        if(this.searchGivingCurrentTimeout)
          clearTimeout(this.searchGivingCurrentTimeout);
      }
    },
    givenCurrentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        if(this.searchGivenCurrentTimeout)
          clearTimeout(this.searchGivenCurrentTimeout);
        this.searchGivenCurrentLoading = true;
        this.givenCurrentSearchResult = [];
        this.searchGivenCurrentTimeout = setTimeout(() => {
          this.searchGivenCurrentList();
        },1500);
      }
      else
      {
        this.searchGivenCurrentLoading = false;
        if(this.searchGivenCurrentTimeout)
          clearTimeout(this.searchGivenCurrentTimeout);
      }
    }
  }
}
</script>

<style scoped>

</style>